import { reactive } from 'vue';
import { Offcanvas } from 'bootstrap';

const state = reactive({
    offcanvases: {},
});

/**
 * オフキャンバスを登録
 *
 * @param {string} name
 * @param {Function} onOpen
 * @param {Function} onClose
 * @param {HTMLElement} elm
 */
export function setOffcanvas(name, onOpen, onClose, elm) {
    const offcanvas = new Offcanvas(elm);
    elm.addEventListener('show.bs.offcanvas', onOpen);
    elm.addEventListener('hide.bs.offcanvas', onClose);
    state.offcanvases[name] = {
        offcanvas,
        onOpen,
        onClose,
        elm,
    };
}

/**
 * オフキャンバスを削除
 *
 * @param {String} name
 */
export function unsetOffcanvas(name) {
    if (state.offcanvases[name]) {
        const { elm, onOpen, onClose } = state.offcanvases[name];
        elm.removeEventListener('show.bs.offcanvas', onOpen);
        elm.removeEventListener('hide.bs.offcanvas', onClose);
        delete state.offcanvases[name];
    }
}

/**
 * 使用するオフキャンバスの名前を引数に取り、そのオフキャンバスを開閉する関数を返す
 *
 * @param {String} name
 * @returns {{openModal: openModal, closeModal: closeModal}}
 */
export default function useOffcanvas(name) {
    const openOffcanvas = () => {
        if (state.offcanvases[name]) {
            const { offcanvas } = state.offcanvases[name];
            offcanvas.show();
        }
    };

    const closeOffcanvas = () => {
        if (state.offcanvases[name]) {
            const { offcanvas } = state.offcanvases[name];
            offcanvas.hide();
        }
    };

    return {
        openOffcanvas,
        closeOffcanvas,
    };
}
